import ShopperEngagementChartIllustration from './assets/shopper-engagement-chart-illustration.svg';
import TopProductsChartIllustration from './assets/top-products-chart-illustration.svg';
import TopProductsTableIllustration from './assets/top-products-table-illustration.svg';
import TagsIllustration from './assets/tags-illustration.svg';
import Hidden from 'raydiant-elements/layout/Hidden';
import CallToAction from './CallToAction';

const VIOnlyLayout = () => {
  const renderDesktopLayout = () => {
    return (
      <div className="p-6">
        <CallToAction />
        <div className="p-6">
          <div className="flex rounded-3xl justify-center gap-6">
            <div>
              <img
                src={ShopperEngagementChartIllustration}
                alt="shopper engagement chart"
              />
            </div>
            <div>
              <img
                src={TopProductsChartIllustration}
                alt="top products chart"
              />
            </div>
          </div>
          <div className="flex rounded-3xl justify-center gap-6 mt-3">
            <div>
              <img
                src={TopProductsTableIllustration}
                alt="top products table"
              />
            </div>
            <div>
              <img src={TagsIllustration} alt="tags" />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderMobileLayout = () => {
    return (
      <div className="p-1">
        <CallToAction />
        <div>
          <div className="flex rounded-3xl flex-col">
            <div className="flex justify-center p-4 mt-3">
              <img
                src={ShopperEngagementChartIllustration}
                alt="shopper engagement chart"
              />
            </div>
            <div>
              <img
                src={TopProductsChartIllustration}
                alt="top products chart"
              />
            </div>
          </div>
          <div className="flex rounded-3xl flex-col">
            <div>
              <img
                src={TopProductsTableIllustration}
                alt="top products table"
              />
            </div>
            <div className="flex justify-center p-4">
              <img src={TagsIllustration} alt="tags" />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="card">
      <Hidden xsDown>{renderDesktopLayout()}</Hidden>
      <Hidden smUp>{renderMobileLayout()}</Hidden>
    </div>
  );
};

export default VIOnlyLayout;
